module.exports = __webpack_public_path__ + "assets/devices/SMD-427-PG2-59d767b48fc705bbb9f0523144df182c.svg";